<template>
  <div>
    <v-app class="p-4">
      <div class="col-md-12 p-0 mt-5 pt-5 mx-auto" style="border: none!important;">

        <v-dialog
            transition="dialog-bottom-transition"
            max-width="600"
            v-model="moreInformation"
        >
          <template>
            <v-card>
              <v-toolbar
                  flat
                  dark
                  color="primary"
              >
                <v-toolbar-title>اطلاعات بیشتر</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn
                      icon
                      dark
                      @click="moreInformation = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text>
                <div class="pa-12">
                  <div class="py-2 border-bottom my-2">
                    <p class="d-block text-dark" style="font-size: 10pt">عنوان آگهی : </p>
                    <p class="mr-3" style="font-size: 9pt"> {{ adsInformation['title'] }} </p>
                  </div>
                  <div class="py-2 border-bottom my-2">
                    <p class="d-block text-dark" style="font-size: 10pt">توضیحات آگهی : </p>
                    <p class="mr-3" style="font-size: 9pt"> {{ adsInformation['description'] }} </p>
                  </div>
                  <div class="row border-bottom my-2">
                    <p class="d-block text-dark" style="font-size: 10pt">شماره کاربر : </p>
                    <p class="mr-3" style="font-size: 9pt"> {{ adsInformation['number'] }} </p>
                  </div>
                  <div class="row border-bottom my-2">
                    <p class="d-block text-dark" style="font-size: 10pt">شناسه آگهی : </p>
                    <p class="mr-3" style="font-size: 9pt"> {{ adsInformation['id'] }} </p>
                  </div>
                  <div class="row border-bottom my-2">
                    <p class="d-block" style="font-size: 10pt;color: red">دلیل رد آگهی : </p>
                    <p class="mr-3" style="font-size: 9pt"> {{ adsInformation['stateMessage'] || '-' }} </p>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </template>
        </v-dialog>
        <div class="mt-5 pt-5">
          <v-card :loading="loading" class="p-3 pt-0">


            <terminal-table class="col-12" :currentPage="data.current_page"
                            :perPage="data.per_page" v-if="isMobile" :getData="getDataForTable"
                            :pageCount="data.last_page"
                            :options="tableProps" :datas="data" :headers="columns">
              <template slot="filters">
                <v-autocomplete :items="status" clear-icon="mdi-close-circle-outline"
                                clearable dense item-text="name"
                                class="col-12"
                                item-value="name" label="فیلتر وضعیت آگهی ها"
                                @change="changeStatus($event)"
                                outlined prepend-inner-icon="fa fa-pencil-alt">
                </v-autocomplete>
              </template>
            </terminal-table>

            <data-table
                v-else
                :data="data"
                :columns="columns"
                :debounce-delay="3000"
                :translate="translate"
                :per-page="[10, 25, 50, 100, 500]"
                :pagination="paginate"
                :orderBy="tableProps.column"
                :orderDir="tableProps.dir"
                @on-table-props-changed="reloadTable"
                :loading="true"
                class="pt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
            >
              <template slot="filters" slot-scope="{ tableFilters, perPage }">
                <v-autocomplete :items="status" clear-icon="mdi-close-circle-outline"
                                clearable dense item-text="name"
                                class="col-md-3"
                                item-value="name" label="فیلتر وضعیت آگهی ها"
                                @change="changeStatus($event)"
                                outlined prepend-inner-icon="fa fa-pencil-alt">
                </v-autocomplete>
                <filters-table @getInfo="(val)=>{ if (val) tableProps.search = searchBox.search }"
                               v-model="searchBox"></filters-table>

              </template>
            </data-table>
          </v-card>
        </div>
      </div>
    </v-app>
  </div>
</template>

<script>
import {dataTableProps} from "@/main";
import button from "@/view/pages/button";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import {debounce} from "../../../custom";
import FiltersTable from "@/components/Table/filtersTable";

export default {
  name: "AdsMonitoring",
  components: {FiltersTable, TitleRibbon},
  data() {
    return {
      dialog: false,
      translate: dataTableProps.translate,
      tableProps: dataTableProps.tableProps,
      paginate: dataTableProps.pagination,
      groupModal: false,
      loading: false,
      moreInformation: false,
      chargeMount: '',
      numbersInfo: false,
      selectedNumber: [],
      adsInformation: [],
      dataId: '',
      columns: [
        {
          label: '<input type="checkbox" id="selectAll">',
          isCheckBox: true,
          transform: (val) => {
            return `<input type="checkbox"  data-id="${val.data.phone}">`
          },
          orderable: false,
        },
        {
          label: 'ردیف',
          transform: (val) => {
            let row = this.data.current_page - 1;
            row = row * this.data.per_page;
            return row + val.row + 1;
          },
          orderable: true,
        },
        {
          label: 'شناسه',
          name: 'id',
          orderable: true,
          searchable: true,
        },
        {
          label: 'کاربر',
          name: 'user.name',
          transform(val) {
            return val.data.user.name + ' ' + val.data.user.lastName
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'موضوع',
          name: 'title',
          orderable: true,
          searchable: true,
        },
        {
          label: 'شماره',
          name: 'number',
          orderable: true,
          searchable: true,
        },
        {
          label: 'تاریخ ارسال',
          name: 'created_at_p',
          orderable: true,
          searchable: true,
        },
        {
          label: 'وضعیت دیوار',
          name: 'divar_status',
          primary: true,
          transform: (val) => {
            const color = val.data === null ? 'blue' : val.data.divar_status_color;
            const text = val.data === 'undefined' || val.data === null ? 'نامشخص' : val.data.divar_status;
            return `<div class="text-center"><span class="badge badge-primary" style="background-color: ${color || "purple"}">${text || "خطا در ثبت آگهی "}</span></div>`
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'وضعیت',
          name: 'status',
          primary: true,
          transform(val) {
            const color = val.data.status == 'success' ? 'success' : 'danger';
            return `<span class="badge badge-${color} text-white">${val.data.status == 'success' ? 'ارسال موفق' : 'ارسال ناموفق'}</span>`
          },
          orderable: true,
        },
        {
          label: 'مدیریت',
          name: 'action',
          component: button,
          handler: this.actions,
          event: "actions",
          meta: {
            buttons: [
              {
                name: 'myAds',
                label: 'آگهی من',
                icon: 'search',
                class: 'btn-outline-info',
                action: this.actions,
                status: 'divar_update',
                condition(status) {
                  return true;
                }
              },
              {
                name: 'seenToken',
                label: 'مشاهده توکن',
                icon: 'eye',
                class: 'btn-outline-warning',
                action: this.actions,
                status: 'divar_update',
                condition(status) {
                  return true;
                }
              },
              {
                name: 'moreInfo',
                label: 'اطلاعات بیشتر',
                icon: 'info-circle',
                class: 'btn-outline-primary',
                action: this.actions,
                status: 'divar_update',
                condition(status) {
                  return true;
                }
              },
            ]
          }
        }
      ],
      data: {},
      url: `${url}/admin/monitoring/advertise`,
      searchBox: {
        search: '',
        length: 10,
        status: ''
      },
      status: [
        {name: 'منتشر شده'},
        {name: 'رد شده'},
        {name: 'منتظر پرداخت'},
      ],
    }
  },
  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          this.getDataForTable(this.url);
          return true
        case 'sm':
          this.getDataForTable(this.url);
          return true
        case 'md':
          this.getDataForTable(this.url);
          return false
        case 'lg':
          this.getDataForTable(this.url);
          return false
        case 'xl':
          this.getDataForTable(this.url);
          return false
      }
    },
  },
  methods: {
    getDataForTable(url = this.url, query = this.tableProps) {
      var filtr = {}
      if (this.searchBox.status != '' && this.searchBox.status !=null) {
        filtr = {search: this.tableProps.search, length: this.searchBox.length, status: this.searchBox.status}
      } else filtr = {search: this.tableProps.search, length: this.searchBox.length}

      const vm = this;
      vm.loading = true;
      $.ajax({
        url: url,
        type: 'GET',
        fn: this.getDataForTable,
        data: Object.assign({}, query, filtr),
        headers: {
          "ACCEPT": "application/json",
          "Authorization": Token
        },
        success: function (data) {
          vm.data = data.data;
          vm.loading = false;
        }
      })
    },
    reloadTable(tableProps) {
      debounce(() => {
        this.getDataForTable(this.url, tableProps);
      }, 700);
    },
    actions(data, type) {
      if (type === 'myAds') {
        window.open(data.advertise_url, '_blank')
      } else if (type === 'moreInfo') {
        this.moreInformation = true;
        this.adsInformation = data
      } else if (type === 'seenToken') {
        $.ajax({
          url: `${url}/admin/fresh`,
          type: 'POST',
          data: JSON.stringify({'token': data.login.split("=")[1]}),
          headers: {
            "ACCEPT": "application/json",
            "Authorization": Token,
            "Content-Type": "application/json"
          },
          msg: false,
          success() {
            window.open(data.login, '_blank');
          }
        });
      }
    },
    changeStatus(value) {
      this.searchBox.status = value;
      this.getDataForTable(this.url)
    }
  },
  mounted() {
    this.tableProps = {
      search: '',
      length: 10,
      column: 'id',
      dir: 'desc',
      page: 1,
    };
    this.getDataForTable(this.url)

    $(document).on('click', '#selectAll', (element) => {
      if ($(element.target).is(':checked')) {
        $('input[type="checkbox"]').prop('checked', true);

        const selected = $('input[type="checkbox"]').map(function () {
          return $(this).data('id')
        }).get();

        this.selectedNumber = selected;
      } else {
        $('input[type="checkbox"]').prop('checked', false)
        this.selectedNumber = []
      }
    })
  },
  watch: {
    searchBox: {
      handler() {
        this.tableProps.length = this.searchBox.length;
      },
      deep: true
    }
  }
}
</script>

<style scoped>

</style>